export default class UnavailabilityApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getUnavailabilities(userId = null, params, httpConfig) {
    const requestParams = params || {};
    if (userId) {
      requestParams.userId = userId;
    }

    return this.httpGet('availability', requestParams, httpConfig);
  }

  getUnavailabilitySetDetails(setId, params, httpConfig) {
    return this.httpGet(`availability/${setId}`, params, httpConfig);
  }

  createUnavailability(availabilitySet, params, httpConfig) {
    return this.httpPost('availability', availabilitySet, params, httpConfig);
  }

  updateUnavailability(availabilitySet, params, httpConfig) {
    return this.httpPut(`availability/${availabilitySet.id}`, availabilitySet, params, httpConfig);
  }

  deleteUnavailability(setId, params, httpConfig) {
    return this.httpDelete(`availability/${setId}`, params, httpConfig);
  }

  approveUnavailability(availabilitySet, params, httpConfig) {
    availabilitySet.approved = true;
    return this.updateUnavailability(availabilitySet, params, httpConfig);
  }

  denyUnavailability(setId, params, httpConfig) {
    return this.deleteUnavailability(setId, params, httpConfig);
  }
}
